import { useEffect, useState } from 'react';
import constants from 'src/modules/Utils/constants';

import { AdvancedVideo } from '@cloudinary/react';
import { Cloudinary } from '@cloudinary/url-gen';
import { getActiveScreenChannelOptions } from 'src/modules/Redux';
import { useAppSelector } from 'src/modules/Redux/store';

const myCld = new Cloudinary({
    cloud: {
        cloudName: constants.cloudinaryCloud,
    },
});

export const VideoPage = () => {
    const channelOptions = useAppSelector(getActiveScreenChannelOptions);
    const publicId = channelOptions?.options.cloudinaryResult.public_id;
    const [video, setVideo] = useState<null | any>(null);

    useEffect(() => {
        if (publicId) {
            const video = myCld.video(publicId);
            setVideo(video);
        }
    }, [publicId]);

    if (!video) return null;

    return (
        <AdvancedVideo
            // autoplay tag needs to be first!
            autoPlay
            // @ts-ignore
            style={{
                height: '100vh',
                width: '100vw',
                backgroundColor: 'black',
            }}
            loop
            cldVid={video}
        />
    );
};
